import { createSelector } from 'reselect';

const selectAccountCodeList = (state) => state.accountCodes.list;

// Assuming `selectAccountCodeList` is the base selector that provides the list of account codes
export const getAccountCodeList = createSelector(
  [selectAccountCodeList],
  (accountCodeList) => {
    // Organize the accounts into categories
    const categories = {};

    accountCodeList.forEach((accountCode) => {
      const { accountCategory, accountNumber, accountName, accountDescription, project } = accountCode;
      const label = `${accountNumber} - ${accountName}`;
      const value = `${accountNumber} - ${accountName}`;
      // Group by accountCategory
      if (!categories[accountCategory]) {
        categories[accountCategory] = [];
      }

      categories[accountCategory].push({
        value,     // Combined label with accountNumber and accountName
        label,                    // Combined label with accountNumber and accountName
        accountDescription,       // You can include additional fields as needed,
        project
      });
    });

    // Convert the categories object into an array of groups with label and options
    return Object.keys(categories).map((category) => ({
      label: category,            // Category label for grouping
      options: categories[category],  // Options within each category
    }));
  }
);


